import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../service/urlcanonica.service';
import { LicitacionService } from '../../../service/licitacion.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-listado-ofertas',
  templateUrl: './listado-ofertas.component.html',
  styleUrls: ['./listado-ofertas.component.css']
})
export class ListadoOfertasComponent implements OnInit {
	private subscription: Subscription = new Subscription();
	RouteText : any;
	tituloseo: any;
	urlcanonicaseo: any;
	imagenseo: any;
	keywordsseo: any;
	descripcionseo: any;
	toggle:boolean = true;
	familias!: any[];
	ofertas!: any[];
	ofertasend: any;
	eventcheked: any;
	confirma = false;
	success= false;
  	fail = false;
	succes = false;
	isFocus = false;
	theHtmlString : any;

constructor( 
	private meta: Meta,
	private title: Title,
	private _seoService: SeoService,
	private router: Router,
	private _licitacionservice: LicitacionService,
	private _urlcanonicaservice: UrlcanonicaService
	) { 
		if((sessionStorage.getItem('token') == null || sessionStorage.getItem('token') == 'null')||(sessionStorage.getItem('rfc') == null || sessionStorage.getItem('rfc') == 'null')){
			this.router.navigate(['/licitaciones/login']);
		}
		this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
			this.RouteText = event;
			this.getSEO(event.url)
		});
	}

	getSEO(page: string) {
		this._seoService.getSEO(page).subscribe((resp: any) => {
			this.tituloseo = resp.titulo;
			this.descripcionseo = resp.descripcion;
			this.urlcanonicaseo = resp.urlcanonica;
			this.imagenseo = resp.image;
		
			this._urlcanonicaservice.createCanonicalLink();
			this.title.setTitle(this.tituloseo)
			this.meta.updateTag({name: 'description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:card',content: 'summary'})
			this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
			this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
			this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/login'})
			this.meta.updateTag({property: 'og:title',content: this.tituloseo})
			this.meta.updateTag({property: 'og:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
		});
	}
	

	ngOnInit(): void {
		this.getFamilias();
		this.getOfertas();
	}

    getFamilias() {
        this.subscription.add(
            this._licitacionservice.getFamiliaIntere().subscribe((resp: any) => {
				this.familias = resp;
            })
        );
    }

	getOfertas() {
        this.subscription.add(
            this._licitacionservice.getOfertas(sessionStorage.getItem('token')).subscribe((resp: any) => {
				this.ofertas = resp;
            })
        );
    }

	goPostulacion(oferta: any) {
		this.ofertasend = oferta;
		this.confirma = true;
	}

	//////////

	cancel() {
		this.confirma = false;
	}
	closeok() {
		this.success= false;
		this.fail = false;
	}
	
	gopro(){
		let currentUrl = this.router.url;
		this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
			this.router.navigate([currentUrl]);
			
		});
	}

	goChange() {
		this.confirma = true;  
		const params = {
			"rfc":sessionStorage.getItem('rfc'),
			"idProducto": this.ofertasend.id
		}
		this.subscription.add(
			this._licitacionservice.postOfertas(params, sessionStorage.getItem('token')).subscribe((resp: any) => {
				this.theHtmlString = resp.message;
				if (resp.ok == false) {
					this.fail = true;
					this.confirma = false;
				} else if (resp.ok == true) {
					this.success = true;
					this.confirma = false;
				}
			})
		);
	}
	buscador(termino: any) {
		this.isFocus = true;
	
		if (termino.length >= 3) {
		  this.subscription.add(
			this._licitacionservice.productosShare(termino, sessionStorage.getItem('token')).subscribe((resp: any) => {
				this.ofertas = resp;
			})
		  );
		}
	  }


	onBlur(event: any) {
		setTimeout(() => {
		  this.isFocus = false;
		}, 500);
	}


	productosShareFamily(event: any) {
		
		this.subscription.add(
			this._licitacionservice.productosFamilyShare(event, sessionStorage.getItem('token')).subscribe((resp: any) => {
				
				this.ofertas = resp;
			})
		  );
	}

	

}

